// import React, { useState } from "react";
// import { Editor } from "@ckeditor/ckeditor5-core";

// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import infoIcon from "../../assets/info-circle-icon.png";
// import { InputFieldPropsInterface } from "../../utils/constants/Interfaces.constants"; // Reuse the interface

// const EditorField: React.FunctionComponent<InputFieldPropsInterface> = ({
//   labelFor = "",
//   label = "",
//   id,
//   value,
//   name,
//   required = false,
//   className = "",
//   placeholder,
//   disabled = false,
//   toolTip = false,
//   tooltipText = "",
//   onChangeInput,
// }) => {
//   const [editorData, setEditorData] = useState(value || "");

//   const handleEditorChange = (event: any, editor: any) => {
//     const data = editor.getData();
//     //  const plainText = data.replace(/<[^>]+>/g, '');
//     setEditorData(data);

//     if (typeof onChangeInput === "function") {
//       const fakeEvent = {
//         target: {
//           name: name || "",
//           value: data,
//         },
//       } as unknown as React.ChangeEvent<HTMLInputElement>;

//       onChangeInput(fakeEvent);
//     }
//   };

//   // const handleEditorChange = (event: any, editor: any) => {
//   //     const data = editor.getData();

//   //     const plainText = data.replace(/<[^>]+>/g, '');

//   //     setEditorData(plainText);

//   //     if (typeof onChangeInput === 'function') {
//   //         const fakeEvent = {
//   //             target: {
//   //                 name: name || '',
//   //                 value: plainText,
//   //             }
//   //         } as unknown as React.ChangeEvent<HTMLInputElement>;

//   //         onChangeInput(fakeEvent);
//   //     }
//   // };

//   return (
//     <div className="mf-admin-inputfield-container input-container d-flex flex-column">
//       <CKEditor
//         editor={ClassicEditor as unknown as any}
//         data={editorData}
//         onChange={handleEditorChange}
//         disabled={disabled}
//         config={{
//           placeholder: placeholder || "Type here...",
//         }}
//       />
//       {toolTip && (
//         <div className="tooltip-container">
//           <img src={infoIcon} width="14" height="14" alt="info" />
//           <span className="tooltip-text">{tooltipText}</span>
//         </div>
//       )}
//       {label?.length !== 0 && (
//         <label
//           className="text-primary-color weight-400 text-capitalize mf-admin-inputfield-label mb-1"
//           htmlFor={labelFor}
//         >
//           {label}
//         </label>
//       )}
//     </div>
//   );
// };

// export default EditorField;
import React, { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import infoIcon from "../../assets/info-circle-icon.png";
import { InputFieldPropsInterface } from "../../utils/constants/Interfaces.constants";

const EditorField: React.FunctionComponent<InputFieldPropsInterface> = ({
  labelFor = "",
  label = "",
  id,
  value,
  name,
  required = false,
  className = "",
  placeholder,
  disabled = false,
  toolTip = false,
  tooltipText = "",
  onChangeInput,
}) => {
  const [editorData, setEditorData] = useState(value || "");

  const handleEditorChange = (event: any, editor: any) => {
    const data = editor.getData();
    setEditorData(data);

    if (typeof onChangeInput === "function") {
      const fakeEvent = {
        target: {
          name: name || "",
          value: data,
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>;

      onChangeInput(fakeEvent);
    }
  };

  return (
    <div className="mf-admin-inputfield-container input-container d-flex flex-column">
      <CKEditor
        editor={ClassicEditor as any}
        data={editorData}
        onChange={handleEditorChange}
        disabled={disabled}
        config={
          {
            toolbar: {
              items: [
                "heading",
                "|",
                "bold",
                "italic",
                "|",
                "link",
                "blockquote",
                "|",
                "imageUpload",
                "insertTable",
                "|",
                "undo",
                "redo",
              ],
            },
            image: {
              toolbar: [
                "imageStyle:full",
                "imageStyle:side",
                "|",
                "imageTextAlternative",
              ],
            },
            table: {
              contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
            },
            language: "en",
          } as any
        }
      />
      {toolTip && (
        <div className="tooltip-container">
          <img src={infoIcon} width="14" height="14" alt="info" />
          <span className="tooltip-text">{tooltipText}</span>
        </div>
      )}
      {label?.length !== 0 && (
        <label
          className="text-primary-color weight-400 text-capitalize mf-admin-inputfield-label mb-1"
          htmlFor={labelFor}
        >
          {label}
        </label>
        //h
      )}
    </div>
  );
};

export default EditorField;
